Namespace 'CustomerVisualMode'

class CustomerVisualMode.UserSession extends Backbone.Model
  urlRoot: '/customer/visual_mode/sessions/'

  defaults:
    name: ''
    created_at: ''
    updated_at: ''
    confirm_save_on_close: false
    closed: false
    focused: false
    composite_filter_json: '{}'
    refresh_interval_in_seconds: null

  initialize: (_, {defaultFilters = null, filtersFactory = null, accountAttributes = null} = {}) ->
    @defaultFilters = defaultFilters
    @filtersFactory = filtersFactory
    @accountAttributes = accountAttributes || @collection.accountAttributes
    @widgets = new Common.Dashboard.WidgetCollection(@get('widgets'))
    @listenTo @widgets, 'session:widgets:add:finished', =>
      @trigger('session:widgets:add:finished')
    @setUrlForWidgets() unless @isNew()
    sharedSession = @get('shared_session')
    return unless sharedSession
    @sharedSession = new CustomerVisualMode.SharedSession
      id: sharedSession.id
      title: sharedSession.title
      url: sharedSession.url

  findAttribute: (definitionCode) ->
    @accountAttributes.customAttributes.findWhere({code: definitionCode})

  updateFilters: =>
    @trigger('session:pendingFilterChange')
    $.ajax
      url: @url() + '/filters'
      method: 'PUT'
      data: JSON.stringify
        serialized_composite_filter: @_parsedCompositeFilterJSON()
        widgets: @widgets.getWidgetIds()
      contentType: 'application/json'
      success: (response) =>
        @trigger('session:filterChange', response)
      error: ->
        showError(I18n.t('generic_error_message'))

  execute: ->
    @trigger('session:execution:pending')
    $.ajax
      url: @url() + '/execute'
      method: 'POST'
      contentType: 'application/json'
      success: (response) =>
        @trigger('session:execution:finished', response)
      error: ->
        showError(I18n.t('generic_error_message'))

  deleteSharedSession: (success) ->
    @sharedSession.destroy({
      success: (response) =>
        @sharedSession = undefined
        success() if success
        @trigger('session:sharedSessionChange')
      error: -> showError(I18n.t('generic_error_message'))
    })

  createSharedSession: (title, success) =>
    @sharedSession = new CustomerVisualMode.SharedSession
      title: title
      session_id: @get('id')
    @sharedSession.save(null, {
      success: (response) =>
        @trigger('session:sharedSessionChange')
        success(@sharedSession)
      error: -> showError(I18n.t('generic_error_message'))
    })

  isCurrent: =>
    @get('focused') && !@get('closed')

  addWidget: (widget_data) ->
    @trigger('session:widgets:add:pending')
    @widgets.addWidget(widget_data)

  getWidgetCollection: ->
    @widgets

  setUrlForWidgets: ->
    @widgets.setSessionUrl(@url())

  getCompositeFilter: ->
    new CustomerVisualMode.Filters.CompositeFilter
      json: @_parsedCompositeFilterJSON()
      defaultFilters: @defaultFilters || @collection.defaultFilters
      filtersFactory: @filtersFactory || @collection.filtersFactory

  setCompositeFilter: (compositeFilter) ->
    @set('composite_filter_json', JSON.stringify(compositeFilter.toJSON()))

  _parsedCompositeFilterJSON: ->
    JSON.parse @get 'composite_filter_json'

  clone: =>
    $.ajax
      url: @url() + '/clone'
      method: 'POST'
      contentType: 'application/json'
      success: (response) =>
        clonedSession = new CustomerVisualMode.UserSession(response, {
          defaultFilters: @defaultFilters,
          accountAttributes: @accountAttributes,
          filtersFactory: @filtersFactory
        })
        clonedSession.set('confirm_save_on_close', true)
        @collection.addNewSession(clonedSession)
      error: -> showError(I18n.t('generic_error_message'))

class CustomerVisualMode.UserSessions extends Backbone.Collection
  url: '/customer/visual_mode/sessions/'
  model: CustomerVisualMode.UserSession

  initialize: (models = null, options = {}) ->
    @defaultFilters = options.defaultFilters
    @filtersFactory = options.filtersFactory
    @accountAttributes = options.accountAttributes
    super(models, options)

  fetch: (options = {}) ->
    originalSuccess = options.success
    success = (collection, response, options) =>
      originalResult = originalSuccess?(collection, response, options)
      @addNewSession() unless @getOpenSessions().length
      originalResult
    super _.extend({}, options, success: success)

  destroyAll: =>
    $.ajax
      url: @url
      method: 'DELETE'
      data: JSON.stringify(ids: @getSavedSessions().map((session) -> session.get('id')))
      contentType: 'application/json'
      success: =>
        @reset()
        @addNewSession()
      error: ->
        showError(I18n.t('generic_error_message'))

  addNewSession: (session) =>
    @unselectAll()
    session ||= new CustomerVisualMode.UserSession(
      {
        name: I18n.t('customer_visual_mode.new_session.title'),
        closed: false,
        focused: true
      },
      {
        accountAttributes: @accountAttributes
      }
    )
    @add(session)

  getOpenSessions: =>
    @where(closed: false)

  getSavedSessions: =>
    _.filter(@models, (model) -> !model.isNew())

  unselectAll: =>
    @selectedSession()?.set(focused: false)

  unselectAllExcluding: (id) =>
    _.each(@where(focused: true), (session) ->
      session.set(focused: false) unless session.get('id') == id
    )

  selectSession: (session) =>
    return if session.get('focused')
    @unselectAll()
    session.set(focused: true, closed: false)
    session.save() unless session.isNew()

  saveSelectedSession: =>
    @selectedSession()?.save({}, {
      success: (session) ->
        session.set('confirm_save_on_close', true)
        session.setUrlForWidgets()
        session.widgets.reset(session.get('widgets'))
      }
    )

  selectedSession: =>
    @findWhere(focused: true)

  destroy: (session) =>
    @selectNearest(session)
    session.destroy()

  closeSession: (session) =>
    @selectNearest(session)
    session.set(closed: true, focused: false)
    session.save()

  selectNearest: (session) =>
    openSessions = @getOpenSessions()
    closedSessionIndex = openSessions.indexOf(session)
    if session.get('focused')
      sessionToSelect = openSessions[closedSessionIndex + 1] || openSessions[closedSessionIndex - 1]
      if sessionToSelect
        @selectSession(sessionToSelect)
      else
        @addNewSession()

  renameSession: (session, name) ->
    session.save({name: name})
